import { TableCell, TableHead, TableRow } from '@mui/material'
import { FormattedMessage } from 'react-intl'

function IntegrationsTableHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell width={58} />
        <TableCell>
          <FormattedMessage id="account.cards.apps.table.headCell.name" />
        </TableCell>
        <TableCell width={120}>
          <FormattedMessage id="account.cards.apps.table.headCell.added" />
        </TableCell>
        <TableCell width={36} />
      </TableRow>
    </TableHead>
  )
}

export default IntegrationsTableHeader
